import { ZervantTemplateSettingsArea } from '@features/invoicingSettings/types/templates/zervantTemplateSettingsArea'

import { InvoiceSettingsForm } from '../../types/invoiceSettingsForm'

export const getTemplateAreasPayload = (formData: InvoiceSettingsForm): ZervantTemplateSettingsArea[] => {
  const formValueToTemplateColorArea: { key: keyof InvoiceSettingsForm; value: ZervantTemplateSettingsArea }[] = [
    { key: 'shouldApplyTemplateColorToColumnHeaders', value: 'columnHeaders' },
    { key: 'shouldApplyTemplateColorToDividers', value: 'dividers' },
    { key: 'shouldApplyTemplateColorToHeader', value: 'header' },
    { key: 'shouldApplyTemplateColorToTotal', value: 'total' },
  ]

  return formValueToTemplateColorArea.filter(({ key }) => formData[key] === true).map(({ value }) => value)
}
